<div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
        <div
            class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-warning text-white m-0 d-130">
            <fa-icon [icon]="['far', 'dot-circle']" class="d-flex align-self-center display-3"></fa-icon>
        </div>
    </div>
    <div class="font-weight-bold font-size-lg mt-4">{{title}}</div>
    <!-- <p class="mb-0 mt-2 text-muted">Use the helper classes to style these paragraphs!</p> -->
    <div class="pt-4">
        <button (click)="decline()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
            <span class="btn-wrapper--label">
                Cancel
            </span>
        </button>
        <button (click)="confirm()" class="btn btn-pill btn-outline-warning mx-1" type="button">
            <span class="btn-wrapper--label">
                Yes, do it
            </span>
        </button>
    </div>
</div>